import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {Product} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<Product, 'id'>,
    handleSubmit: (values: Product) => void,
    handleCancel?: () => void
}) => {

    // FNP-918 (§6): `onSubmit` is ASYNC and RETURNS the mutation promise.
    //
    // It previously called `handleSubmit(values)` and dropped the promise on the
    // floor. Formik then cleared `isSubmitting` on the same tick, so the shared
    // button's `disabled={isSubmitting}` never engaged and double-submit was
    // live — a double-submitted create is two identical products in the
    // catalogue.
    //
    // It also breaks the drawer above it: FormDrawer does `await
    // handleSubmit(values); onClose();`, which is the CORRECT shape, but
    // awaiting a dropped promise resolves immediately — so a server-side
    // rejection still closed the drawer and destroyed the operator's input.
    const onSubmit = async (values: Product) => {
        await handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {} as Product;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
